import {IVectorizedFeedbackModelRequest} from "../../types/vectorization";
import {ToastError} from "../../utils/toastUtil";
import {submitFeedback} from "../../api/vectorization";


export const vectorizationSubmitFeedback = async (request: IVectorizedFeedbackModelRequest) => {
    try {
        return await submitFeedback(request);
    } catch (error) {
        console.error(`startVectorizationProcess ${error}`);
        ToastError(error as string);
        return "";
    }
}

